var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { messages, select } from './messages';
import { UploadInput } from './UploadInput';
/**
 * @hidden
 */
var UploadAddButton = /** @class */ (function (_super) {
    __extends(UploadAddButton, _super);
    function UploadAddButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            _this.props.onClick.call(undefined, _this.props.addButtonIndex);
        };
        return _this;
    }
    UploadAddButton.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, navigationIndex = _a.navigationIndex, addButtonIndex = _a.addButtonIndex, notFocusedIndex = _a.notFocusedIndex;
        if (navigationIndex !== prevProps.navigationIndex &&
            prevProps.navigationIndex !== notFocusedIndex &&
            navigationIndex === addButtonIndex &&
            this._element) {
            this._element.focus();
        }
    };
    UploadAddButton.prototype.inputRef = function () {
        if (this._uploadInput) {
            return this._uploadInput.inputRef();
        }
    };
    UploadAddButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, navigationIndex = _a.navigationIndex, addButtonIndex = _a.addButtonIndex, tabIndex = _a.tabIndex, others = __rest(_a, ["navigationIndex", "addButtonIndex", "tabIndex"]);
        var localizationService = provideLocalizationService(this);
        var selectMessage = localizationService.toLanguageString(select, messages[select]);
        var buttonClassName = classNames('k-button', 'k-upload-button', navigationIndex === addButtonIndex ? 'k-state-focused' : '');
        return (React.createElement("div", { ref: function (ref) { return _this._element = ref; }, role: "button", className: buttonClassName, "aria-label": selectMessage, tabIndex: tabIndex, onClick: this.onClick },
            React.createElement(UploadInput, __assign({}, others, { ref: function (ref) { return _this._uploadInput = ref; } })),
            React.createElement("span", null, selectMessage)));
    };
    return UploadAddButton;
}(React.Component));
export { UploadAddButton };
registerForLocalization(UploadAddButton);
//# sourceMappingURL=UploadAddButton.js.map